<template>
  <div class="btn-pay-wrapper">
    <div
      class="btn-pay"
      :class="{ disabled: !isAgree }"
      @click="$emit('click')"
    >
      立即报名
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ButtonV2 extends Vue {
  @Prop({ type: Object, default: () => ({}) }) config!: any;
  @Prop({ type: Boolean, default: true }) isAgree!: boolean;
}
</script>

<style lang="scss" scoped>
@import '@style/helps.scss';
.btn-pay-wrapper {
  width: 297px;
  height: 116px;
  background: #fff;
  border-radius: 12px;
}
.btn-pay {
  @include forbid-select;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 14px 0 16px;
  color: #fff;
  font-weight: 600;
  font-size: 50px;
  background: #ea632f;
  border-radius: 12px;
  &:active:not(.disabled) {
    opacity: 0.7;
  }
  &.disabled {
    opacity: 0.3;
  }
}
</style>